module.exports = __webpack_public_path__ + "static/media/Taquitos norteños con mayonesa.63dcd366.webp";